import React, { cloneElement, forwardRef, isValidElement } from 'react';

import { useMergeRefs } from '@floating-ui/react';

import { type TriggerElementProps } from '@pkg/components';

export const Trigger = forwardRef<HTMLElement, TriggerElementProps>(function Trigger(
    { children, context, asChild = false, ...props },
    propRef,
) {
    if (context == null) {
        throw new Error('Item must be wrapped');
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const childrenRef = (children as any).ref;
    const ref = useMergeRefs([context.refs.setReference, propRef, childrenRef]);

    if (asChild && isValidElement(children)) {
        return cloneElement(
            children,
            context.getReferenceProps({
                ref,
                ...props,
                ...children.props,
                'data-state': context.open ? 'open' : 'closed',
            }),
        );
    }

    return (
        <span ref={ref} data-state={context.open ? 'open' : 'closed'} {...context.getReferenceProps(props)}>
            {children}
        </span>
    );
});
